import { NumericTextBox } from '@progress/kendo-react-inputs';
import MarkerText from '../../../../components/inputs/MarkerText';
import { useSettingNumericValue } from '../../../home/hooks/settings';
import { useSearchContext } from '../../context/SettingsSearchContext';

export function SettingsViewsSlideShowPeriod() {
    const context = useSearchContext();
    const value = useSettingNumericValue('timeToShowEachViewSeconds');
    return (
        <div className="px-3 d-flex align-items-center justify-content-between">
            <div>
                <MarkerText highlight={context.term}>Time to show each View in Slideshow mode</MarkerText>
            </div>
            <div>
                <NumericTextBox format={'0 seconds'} min={3} {...value} />
            </div>
        </div>
    );
}
